import { Component, forwardRef, Inject, Input, Optional } from '@angular/core';
import { Router } from '@angular/router';
import {
  BaseWidget,
  NgAisIndex,
  NgAisInstantSearch
} from 'angular-instantsearch';
import { connectAutocomplete } from 'instantsearch.js/es/connectors';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'front-app-autocompleteSeach-service',
  templateUrl: './autocompleteSeach-service.component.html',
  styleUrls: ['./autocompleteSeach-service.component.scss']
})
export class AutocompleteSeachServiceComponent extends BaseWidget {
  @Input() public attribute: string;
  searchParameters = {
    query: '',
    filters: 'appKey.appKey:' + environment.appKey
  };

  state: {
    query: string;
    refine: Function;
    indices: object[];
  };
  public client: string;
  constructor(
    private router: Router,
    @Inject(forwardRef(() => NgAisIndex))
    @Optional()
    public parentIndex: NgAisIndex,
    @Inject(forwardRef(() => NgAisInstantSearch))
    public instantSearchInstance: NgAisInstantSearch
  ) {
    super('AutocompleteSeachServiceComponent');
  }

  public handleChange($event: KeyboardEvent) {
    this.state.refine(($event.target as HTMLInputElement).value);
  }

  ngOnInit(): void {
    // get client for css
    this.client = `?client=${localStorage.getItem('client')}`;
    this.createWidget(connectAutocomplete, {});
    super.ngOnInit();
  }

  goToDetailService(option: any) {
    const titleService = option.title
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      .map((x) => x.toLowerCase())
      .join('-');
    const url = `/webcliente/services/${option.id}-${titleService}${this.client}`;
    this.router.navigateByUrl(url);
  }
}
